import { InjectionToken } from '@angular/core';

export const billingAddressFormTranslations = {
  companyName: 'app.pricing.billing_address_form.company_name',
  country: 'app.pricing.billing_address_form.country',
  region: 'app.pricing.billing_address_form.region',
  address: 'app.pricing.billing_address_form.address',
  city: 'app.pricing.billing_address_form.city',
  postalCode: 'app.pricing.billing_address_form.postal_code',
  vat: 'app.pricing.billing_address_form.vat_number',
  vatSupportLink: 'app.support_resources.vat_validation',
  vatHint: 'app.pricing.billing_address_form.vat_number_hint',
};

export type BillingAddressFormTranslations = typeof billingAddressFormTranslations;

export const BillingAddressFormTranslationsToken = new InjectionToken<
  typeof billingAddressFormTranslations
>('BillingAddressFormTranslationsToken');
